import type { LocalInfoType } from '@/apis/common.types';
import { createRoot, Root } from 'react-dom/client';
import { BUTTON_TYPE } from '../const';
import { ServiceFloorData } from '../interface';
import ServiceGuaranteeDrawer from './drawer';

interface DrawerProps {
  title?: string; //标题
  mainSkuId: string; //商品SkuId
  btnType: BUTTON_TYPE; //底部展示按钮类型
  useShareCheck?: boolean; //服务选择态是否同步缓存
  addCart?: (param: {}) => void; //加车点击回调
  buyNow?: (param: {}) => void; //立即购买点击回调
  onConfirm?: (param: {}) => void; //确认按钮点击回调
  onClose?: () => void; // 抽屉关闭回调
  isInitialized?: boolean; //没初始化，不请求服务数据需要传入 serviceData和localInfo
  localInfo?: LocalInfoType; //货币信息
  serviceData?: ServiceFloorData; //服务数据
  serviceItemIds?: string[]; // 选择的服务ID列表
}

export default class ServiceController {
  private element: HTMLElement;
  private root: Root | null = null;
  private isOpen: boolean = false;
  private onClose: (() => void) | null = null;
  private static instance: ServiceController;

  private constructor() {
    this.element = document.createElement('div');
    document.body.appendChild(this.element);
  }

  static getInstance(): ServiceController {
    if (!this.instance) {
      this.instance = new ServiceController();
    }
    return this.instance;
  }

  private handleClose = () => {
    this.isOpen = false;
    this.onClose?.();
    this.cleanup();
  };

  private cleanup() {
    if (this.root) {
      setTimeout(() => {
        if (!this.isOpen && this.root) {
          this.root.unmount();
          this.root = null;
          if (document.body.contains(this.element)) {
            document.body.removeChild(this.element);
          }
          if (this.onClose) {
            this.onClose = null;
          }
        }
      }, 300); // 留出动画时间
    }
  }

  openDrawer(params: DrawerProps) {
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    if (!this.root) {
      this.root = createRoot(this.element);
    }
    this.root.render(
      <ServiceGuaranteeDrawer
        {...params}
        open={this.isOpen}
        closeFn={() => {
          this.onClose = params?.onClose || null;
          this.handleClose();
        }}
      />,
    );
  }

  // 防止内存泄漏
  destroy() {
    this.handleClose();
  }
}
